package kz.dentalcrm.app.screens.reply_by_template.mvi

import kz.dentalcrm.app.core.base.ViewSideEffect

sealed interface ReplyByTemplateViewSideEffect : ViewSideEffect {
    data class OpenUrl(val url: String) : ReplyByTemplateViewSideEffect
    data object NavigateBack : ReplyByTemplateViewSideEffect
}
